<template>
  <dl class="list list--definition list--clean">
    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY.NAME') }}</dt>
    <dd class="text-start" dir="rtl">
      {{ data.name }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY.PACKAGE_NAME') }}</dt>
    <dd class="text-latin" dir="ltr">
      {{ data.packageName }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY.BUDGET') }}</dt>
    <dd class="text-start" dir="ltr">
      {{ priceFormat(data.budget - data.spentBudget) }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY.SPENT_BUDGET') }}</dt>
    <dd class="text-start" dir="rtl">
      {{ priceFormat(data.spentBudget) }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY.DAILY_CAP') }}</dt>
    <dd class="text-start" dir="rtl">
      {{ priceFormat(data.dailyCap) }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY.TARGETED_CPI') }}</dt>
    <dd class="text-start" dir="rtl">
      {{ priceFormat(data.targetedCpi) }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY.START_DATE') }}</dt>
    <dd class="text-start" dir="ltr">
      {{ translateDate(data.startDate) }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY.END_DATE') }}</dt>
    <dd class="text-start" dir="ltr">
      {{ translateDate(data.endDate) }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY.STATUS') }}</dt>
    <dd class="text-start" dir="ltr">
      {{ $t(statusText) }}{{ statusPostfix }}
    </dd>
    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY.TRACKER_STATUS') }}</dt>
    <dd class="text-start" dir="rtl">
      {{ $t(trackerStatus) }}
    </dd>
  </dl>
</template>

<script>
import { dateFormat } from '@/utils/date';
import lang from '@/mixins/lang';
import { format as priceFormat } from '@/utils/number';
import translateCampaignStatus from '../../common/utility/translators/translateCampaignStatus';

export default {
  name: 'CampaignInfoList',
  mixins: [lang],
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    statusPostfix() {
      if (this.data.status === 'not_started' && this.data.paused) {
        return ` (${this.$t('ADVERTISEMENT.CAMPAIGNS.STOPPED')})`;
      }
      return '';
    },
    statusText() {
      return translateCampaignStatus(this.data.status);
    },
    trackerStatus() {
      return this.data.hasTracker
        ? 'ADVERTISEMENT.CAMPAIGNS.HAS_TRACKER'
        : 'ADVERTISEMENT.CAMPAIGNS.DOESNT_HAVE_TRACKER';
    },
  },
  methods: {
    priceFormat,
    translateDate(date) {
      if (!date) return '';

      let toFormat = 'DD/MM/YYYY';

      if (this.lang === 'fa') {
        toFormat = 'jYYYY/jMM/jDD';
      }

      try {
        return dateFormat()(toFormat)(date);
      } catch (error) {
        return date;
      }
    },
  },
};
</script>
